<template>
  <div class="flex flex-col sm:flex-row gap-4 items-center justify-between mb-4">
    <div class="flex flex-col gap-0 w-full">
      <div class="flex justify-between">
        <div class="flex flex-col gap-2 justify-center">
          <Breadcrumb
            v-if="breadcrumb"
            :items="items"
          />
          <div
            v-if="title"
            class="flex items-center gap-4"
          >
            <h1 class="text-2xl font-semibold leading-7 sm:text-3xl sm:tracking-tight">
              {{ title }}
            </h1>
            <slot name="title-append"></slot>
          </div>
          <div
            v-if="description"
            class="text-md text-tertiary"
          >
            {{ description }}
          </div>
        </div>
        <div class="flex-1 flex justify-end">
          <slot name="right"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Breadcrumb from '@/components/page/Breadcrumb.vue'

defineProps({
  align: {
    type: String,
    default: 'left' // center, left
  },
  title: {
    type: String,
    default: null
  },
  description: {
    type: String,
    default: null
  },
  breadcrumb: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array,
    default: () => []
  }
})
</script>

<style></style>
